export const MIN_NUMBER_VALUE = 0;
export const MIN_PERCENT_VALUE = 0;
export const MAX_PERCENT_VALUE = 100;
